import { render } from "./detail.vue?vue&type=template&id=8165226c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=8165226c&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8165226c"],['__file',"src/views/widget/landing/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8165226c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8165226c', __exports__)) {
    console.log('reload')
    api.reload('8165226c', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=8165226c&scoped=true", () => {
    console.log('re-render')
    api.rerender('8165226c', render)
  })

}


export default __exports__